import { CLOSE_MODAL } from '../../utils/constantes'

export default function closeModalImage () {
    return{
        type: CLOSE_MODAL,
    }
}